import { Moon, Sun } from 'lucide-react'
import { useThemeMode } from '../Provider/ThemeContextProvider'

const ThemeModeToggle = ({ className = '' }) => {
  const { darkMode, toggleDarkMode } = useThemeMode()

  const handleToggle = (event) => {
    event.preventDefault()
    event.stopPropagation()
    toggleDarkMode(!darkMode)
  }

  return (
    <button
      type='button'
      aria-label={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-pressed={darkMode}
      data-mode={darkMode ? 'dark' : 'light'}
      className={`fabits-theme-toggle ${className}`}
      onClick={handleToggle}
    >
      <span className='fabits-theme-toggle-thumb' aria-hidden='true' />
      <span className='fabits-theme-toggle-icon fabits-theme-toggle-sun' aria-hidden='true'>
        <Sun size={14} strokeWidth={2.7} />
      </span>
      <span className='fabits-theme-toggle-icon fabits-theme-toggle-moon' aria-hidden='true'>
        <Moon size={14} strokeWidth={2.7} />
      </span>
    </button>
  )
}

export default ThemeModeToggle
